export enum ImportationErrorTypes {
  Error = 'Invalid',
  Success = 'Valid',
  Warning = 'Warning'
}
